<template>
  <v-row class="no-gutters">
    <v-col cols="12" class="pa-1">
      <span :class="claseError">{{ titulo }}</span>
      <span v-if="obligatorio" class="font-weight-bold ml-1" :class="claseError">*</span>
    </v-col>
    <v-col cols="5">
      <v-card outlined height="300" class="cont-list mx-auto" :style="{borderRadius: '0px !important'}">
        <div>
            <v-text-field
              v-model="search"
              label="Buscar"
              filled
              dense
              hide-details
              clearable
              @keydown.enter="onBuscar(false)"
              @click:append="onBuscar(false)"
              @click:clear="onBuscar()"
              @input="onValidarSearch()"
              :append-icon="search ? 'mdi-magnify' : ''"
            />
          </div>
        <div  ref="contenedorListaScroll" style="height: 240px; overflow-y: auto;" @scroll="onRecargarLista">
        <v-list-item-group 
          v-model="selectedItem" 
          color="primary" 
          :key="keyItem"
          multiple
        >
          <v-virtual-scroll
            v-if="itemsData.length !== 0"
            :items="itemsData"
            item-height="50"
            :key="nfilter"
          >
            <template v-slot:default="{ item }">
              <v-list-item :key="item.id" :value="item.id">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.texto }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-virtual-scroll>
        </v-list-item-group>
        </div>
      </v-card>
    </v-col>

    <v-col cols="2" class="text-center align-center justify-center d-flex">
      <div class="d-flex flex-column align-center">
        <v-btn color="primary" class="ma-3" outlined :disabled="selectedItem.length == 0" fab small @click="addItems">
          <v-icon class="btncolor--text">mdi-arrow-right-bold</v-icon>
        </v-btn>
        <v-btn color="primary" class="ma-3" outlined fab small @click="removeItems" :disabled="selectedItemResp.length == 0">
          <v-icon class="btncolor--text">mdi-arrow-left-bold</v-icon>
        </v-btn>
      </div>
    </v-col>

    <v-col cols="5">
      <v-card outlined height="300" class="cont-list mx-auto">
        <v-list-item-group v-model="selectedItemResp" color="primary" multiple>
          <v-list-item v-for="item in aDataResp" :key="item.id" :value="item">
            <v-list-item-content>
              <v-list-item-title class="wrap-text">{{ item.texto }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import FormMixin from "@/mixins/formularioMixin.js";
import axiosServices from "@/services/axiosServices.js";

export default {
  name: "FormAgregarClientes",
  mixins: [FormMixin],
  props: {
    inner: {
      type: String,
      default: "",
    },
    condicion: {
      type: String,
      default: "",
    },
    altValue: {
      type: String,
      default: "",
    },
    oDetalle: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      valor: this.value || [],
      selectedItem: [],
      selectedItemResp: [],
      itemsData: [],
      aDataResp: [],
      search: "",
      keyItem: 0,
      nPagina: 1,
      nItemsxPagina: 100,
      bCargarMas: false,
      bFinalizar: false,
      nfilter: 0
    };
  },
  async mounted() {
    if(this.itemsData.length==0){
      await this.getItems();
    }
  },
  watch: {
    // Solo se actualizará cuando realmente cambien los datos
    aDataResp: {
      handler() {
        this.updateValor();
      },
      deep: true
    },
    search() {
      // Solo incrementamos el contador cuando cambia la búsqueda
      this.nfilter++;
    }
  },
  methods: {
    updateValor() {
      this.$emit('aDataResp', this.aDataResp); // Emitir cambios al componente padre
    },
    
    async getItems() {
      this.bCargarMas = true;
      
      this.loadSelect = true;
      this.Mensaje = "Cargando ..";
      await axiosServices
        .getConfiguration("/crontabs/clientes",true)
        .then((aItems) => {
          let aTempitemsData = aItems.aData;
          if (aTempitemsData.length < this.nItemsxPagina) {
            this.bFinalizar = true;
          }
          let aWithoutSelected = [];
          aTempitemsData.map((el) => {
            aWithoutSelected.push(el)
          });
          this.itemsData = aItems.aData
          this.loadSelect = false;
          this.bCargarMas = false;
          this.Mensaje = "Seleccione " + this.titulo;
          this.keyItem++;
        });
    },
    
    addItems() {
      if (this.selectedItem.length === 0) return;
      
      // Uso de un solo ciclo para procesar todos los elementos seleccionados
      const itemsToAdd = [];
      const indicesToRemove = [];
      
      this.selectedItem.forEach(itemId => {
        const index = this.itemsData.findIndex(item => item.id === itemId);
        if (index !== -1) {
          itemsToAdd.push(this.itemsData[index]);
          indicesToRemove.push(index);
        }
      });
      
      // Actualizamos los arrays en orden inverso para evitar problemas con los índices
      for (let i = indicesToRemove.length - 1; i >= 0; i--) {
        this.itemsData.splice(indicesToRemove[i], 1);
      }
      
      // Agregamos los elementos a la lista de seleccionados
      this.aDataResp.push(...itemsToAdd);
      
      // Limpiamos la selección
      this.selectedItem = [];
    },
    
    removeItems() {
      if (this.selectedItemResp.length === 0) return;
      
      // Clonamos los arrays para evitar problemas de mutación durante la iteración
      const itemsToMove = [...this.selectedItemResp];
      this.itemsData.push(...itemsToMove);
      
      // Filtramos los elementos seleccionados
      this.aDataResp = this.aDataResp.filter(item => 
        !this.selectedItemResp.includes(item)
      );
      
      // Incrementamos los contadores para forzar la actualización del v-virtual-scroll
      this.keyItem++;
      this.nfilter++;
      
      // Limpiamos la selección
      this.selectedItemResp = [];
    },
    onRecargarLista() {
      const xContenedorLIsta = this.$refs.contenedorListaScroll;
      if (!xContenedorLIsta || this.bCargarMas || this.bFinalizar) return;
      const nearBottom = xContenedorLIsta.scrollTop + xContenedorLIsta.clientHeight >= xContenedorLIsta.scrollHeight - 10;
      if (nearBottom) {
        this.nPagina++;
        this.getItems(this.nPagina);
      }
    },
    onBuscar(bLimpiarBusqueda=true){
      if (bLimpiarBusqueda) {
        this.search = "";
      }
      this.itemsData = [];
      this.nPagina = 1;
      this.bCargarMas = false;
      this.bFinalizar = false;
      this.getItems();
    },
    onValidarSearch(){
      if (this.search.trim() === '') {
        this.onBuscar();
      }
    },
    async onAgregarClientes(aClientesTemp){
      if(this.itemsData.length==0){
        await this.getItems();
      }
      this.selectedItem = aClientesTemp;
      this.addItems();
    }
  },
};
</script>
<style lang="scss" scoped>
.cont-list {
  overflow-x: auto !important;
  font-size: 0.9em;
}
.cont-botones {
  width: 100%;
}
.wrap-text {
  word-break: break-word;
  white-space: normal;
}
</style>